import React from 'react';
import PropTypes from 'prop-types';

const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

export default class AsyncAction extends React.Component {
  static propTypes = {
    fireActionOnMount: PropTypes.bool,
    action: PropTypes.func,
    children: PropTypes.func,
    wait: PropTypes.number,
    postWait: PropTypes.number,
  };

  static defaultProps = {
    fireActionOnMount: false,
    action: async () => null,
    children: () => null,
    wait: 0,
    postWait: 0,
  };

  state = {
    working: this.props.fireActionOnMount || false,
    mounting: true,
  };

  componentDidMount() {
    if (this.props.fireActionOnMount) this.onFireAction();
  }

  onFireAction = async (
    preAction = async () => null,
    postAction = async () => null,
  ) => {
    const { wait, action, postWait } = this.props;

    this.setState({ working: true }, async () => {
      if (wait) await sleep(wait);
      if (typeof preAction === 'function') await preAction();
      await action();
      if (postWait) await sleep(postWait);
      this.setState({ working: false, mounting: false });
      if (typeof postAction === 'function') await postAction();
    });
  };

  setWorking = status => this.setState({ working: status });

  render() {
    const { children } = this.props;

    return (
      <>
        {children({
          mounting: this.state.mounting,
          working: this.state.working,
          fireAction: this.onFireAction,
          setWorking: this.setWorking,
        })}
      </>
    );
  }
}
